<section class="container-fluid min-height-container bg-gray-100 pb-5">
    <section class="container pt-5">
        <h1 class="text-center display-3 mb-0"  id="joinNow">Join Now</h1>
        <form class="row g-3 my-5" (ngSubmit)="onSubmit()" novalidate>
            @if(showForm()) {
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="firstName" class="form-label required">Provider First Name</label>
                        <app-signal-input [field]="firstName"></app-signal-input>
                    </div>
                    <div class="col-md-4">
                        <label for="lastName" class="form-label required">Provider Last Name</label>
                        <app-signal-input [field]="lastName"></app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="phoneNumber" class="form-label required">Provider Phone Number</label>
                        <app-signal-input [field]="phoneNumber" [formatted]="true"></app-signal-input>

                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="emailAddress" class="form-label required">Provider E-Mail Address</label>
                        <app-signal-input [field]="emailAddress"></app-signal-input>
                    </div>
                    <div class="col-md-4">
                        <label for="emailAddress" class="form-label required">Verify E-Mail Address</label>
                        <app-signal-input [field]="emailAddress2"></app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-10 offset-md-2 mt-5">
                        <label for="clinicInfo" class="form-label">Clinic Information</label>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-8 offset-md-2 ">
                        <label for="clinicName" class="form-label required">Clinic Name</label>
                        <app-signal-input [field]="clinicName"></app-signal-input>

                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-8 offset-md-2">
                        <label for="address" class="form-label required">Address</label>
                        <app-signal-input [field]="address"></app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-8 offset-md-2">
                        <label for="address2" class="form-label">Address Line 2</label>
                        <app-signal-input [field]="address2"></app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="city" class="form-label required">City</label>
                        <app-signal-input [field]="city"></app-signal-input>
                    </div>
                    <div class="col-md-4">
                        <label for="state" class="form-label">State</label>
                        <app-signal-input [field]="state" type="select">
                            <option value="">-- Select a State --</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="zip" class="form-label required">Zip Code</label>
                        <app-signal-input [field]="zip" [maxLength]="5"></app-signal-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-4 offset-md-2">
                        <label for="groupNpi" class="form-label required">Group NPI</label>
                        <app-signal-input [field]="groupNpi" [maxLength]="10"></app-signal-input>
                    </div>
                    <div class="col-md-4">
                        <label for="individualNpi" class="form-label required">Individual NPI</label>
                        <app-signal-input [field]="individualNpi" [maxLength]="10"></app-signal-input>
                    </div>
                </div>
            }
            <!-- Success/Error Messages -->
             @if(submitMessage) {
                <div class="col-md-8 offset-md-2">
                    <div class="alert" [ngClass]="submitSuccess ? 'alert-success' : 'alert-danger'" role="alert">
                        {{ submitMessage }}
                    </div>
                </div>
            }
            @if(showForm()) {
                <div class="col-md-6 offset-md-3 d-grid my-5">
                    <button 
                        type="submit" 
                        class="btn btn-lg btn-black btn" 
                        [disabled]="loading() || !isFormValid()">
                        @if(loading()) {
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        }
                        {{ loading() ? 'SUBMITTING...' : 'SUBMIT' }}
                        
                    </button>
                </div>
            }
        </form>
    </section>
</section>